import { Controller } from "@hotwired/stimulus"
import { trackWebEvent } from "../src/web_analytics"

export default class extends Controller {
  static values = {
    triggerId: String
  }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return

    this.source = "premium_click"
    this.handleDocumentClick = this.handleDocumentClick.bind(this)
    this.handleDrawerClick = this.handleDrawerClick.bind(this)
    document.addEventListener("click", this.handleDocumentClick, true)
    document.addEventListener("click", this.handleDrawerClick)
  }

  disconnect() {
    document.removeEventListener("click", this.handleDocumentClick, true)
    document.removeEventListener("click", this.handleDrawerClick)
  }

  open(url = null) {
    if (url && this.frame) this.frame.src = url

    const drawer = this.drawer
    if (!drawer) return

    drawer.dispatchEvent(new Event("bottom-drawer:open"))
    if (!drawer.open) return

    trackWebEvent("premium_paywall_modal_shown", {
      path: window.location.pathname,
      surface: "modal",
      source: this.source,
      trigger: "click"
    })
  }

  handleDocumentClick(event) {
    if (event.defaultPrevented || event.button !== 0) return
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    const target = event.target.nodeType === Node.ELEMENT_NODE ? event.target : event.target.parentElement
    const link = target?.closest("a[href]")
    if (!link || link.target === "_blank" || link.hasAttribute("download")) return

    const url = new URL(link.href, window.location.href)
    if (url.origin !== window.location.origin || url.pathname !== "/premium") return
    if (this.onboardingPaywallUrl(url)) return

    event.preventDefault()

    url.searchParams.set("surface", "modal")
    if (!url.searchParams.has("placement")) url.searchParams.set("placement", "click")

    this.source = url.searchParams.get("source") || "premium_click"
    this.open(url.toString())
  }

  handleDrawerClick(event) {
    const drawer = this.drawer
    const target = event.target.nodeType === Node.ELEMENT_NODE ? event.target : event.target.parentElement
    if (!drawer || !drawer.contains(target)) return

    if (target.closest(".dismiss-drawer-button, .overlay")) {
      trackWebEvent("premium_paywall_modal_dismissed", {
        path: window.location.pathname,
        surface: "modal",
        source: this.source,
        trigger: "click"
      })
    }
  }

  onboardingPaywallUrl(url) {
    return window.location.pathname.startsWith("/onboarding") ||
      [url.searchParams.get("source"), url.searchParams.get("placement")]
        .some(value => value?.startsWith("onboarding"))
  }

  get drawer() {
    return document.querySelector(`[data-trigger-id="${this.triggerIdValue}"]`)
  }

  get frame() {
    return this.element.querySelector("turbo-frame#premium_paywall")
  }
}
